import { RedirectValues } from 'types/RedirectItemMenuProps';

export const redirectTypes: { label: string; value: RedirectValues }[] = [
	{
		label: 'Produto',
		value: 'product'
	},
	{
		label: 'URL',
		value: 'url'
	},
	{
		label: 'Tela dinâmica',
		value: 'app_screen'
	},
	{
		label: 'Webview',
		value: 'webview'
	},
	{
		label: 'Query Vtex',
		value: 'query'
	},
	{
		label: 'Telas do app',
		value: 'app_screen_custom'
	},
	{
		label: 'Abas dinâmicas',
		value: 'dynamic_tabs'
	}
];
